export default function Confirm({ open, onClose, onConfirm, children }: { open: boolean, onClose: () => void, onConfirm: () => void, children: any }) {
  if (!open) return null
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-md p-4 w-full max-w-sm shadow">
        <div className="mb-4 text-sm">{children}</div>
        <div className="flex gap-2 justify-end">
          <button className="btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn" onClick={onConfirm}>Confirm</button>
        </div>
      </div>
    </div>
  )
}

